import React from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import PopUp from '../../pages/PopUp';


const Footer = () => {
  return (
    <>
      <footer className="mt_120 xs_mt_100 pt_75" style={{ background: 'url(assets/images/footer_bg.jpg)'}}>
        <div className="container">
          <div className="row">
            <div className="col-12 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp'}}>
              <ul className="footer_top">
                <li>
                  <div className="icon">
                    <img src="assets/images/call_icon_blue.svg" alt="Call" className="img-fluid" />
                  </div>
                  <div className="text">
                    <span>Need Any Cleaning Help</span>
                    <a href="calto:+91 9174282618"> +91 9174282618</a>
                    <br />
                    <a href="calto:+91 9174282618"> +91 8889997714</a>
                  </div>
                </li>
                <li>
                  <div className="icon">
                    <img src="assets/images/mail_icon_blue.svg" alt="Mail" className="img-fluid" />
                  </div>
                  <div className="text">
                    <span>Send Email</span>
                    <a href="mailto:info@sewaxservices.com">info@sewaxservices.com</a>
                  </div>
                </li>
                <li>
                  <div className="icon">
                    <img src="assets/images/location_icon_blue.svg" alt="Location" className="img-fluid" />
                  </div>
                  <div className="text">
                    <span>Our Address</span>
                    <p><a href='https://share.google/Gq3DPhPXAuUojE9pq' target="blank" style={{color:"white"}}>Birla Road Badhiya Near Durga Mandir Sundar Tower 2nd Floor Satna MP
                      PIN Code 485001</a> </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="row justify-content-between">
            <div className="col-md-6 col-lg-3 col-xl-3 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
              <div className="footer_info">
                <a to="index.html" className="footer_logo">
                  <img src="./assets/img/footer_logo.png" alt="SERVIAN" className="img-fluid" />
                </a>
                {/* <p>We offer a range of services including residential cleaning, commercial kinds cleaning,
                  carpet cleaning</p> */}
                <ul className="footer_social d-flex flex-wrap">
                  <li><a target="blank" to="#"><i className="fab fa-instagram" aria-hidden="true" /></a></li>
                  <li><a target="blank" to="#"><i className="fab fa-facebook-f" aria-hidden="true" /></a></li>
                  <li><a target="blank" to="#"><i className="fab fa-youtube" aria-hidden="true" /></a></li>
                </ul>
              </div>
            </div>
            <div className="col-md-6 col-sm-6 col-lg-3 col-xl-2 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
              <div className="footer_link">
                <h3>Services</h3>
                <ul>
                  <li><Link to="#">Security Services</Link></li>
                  <li><Link to="#">Construction Services</Link></li>
                  <li><Link to="#">Property Dealer Services</Link></li>
                  <li><Link to="#">Financial Advisor Services</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-md-6 col-sm-6 col-lg-2 col-xl-2 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
              <div className="footer_link footer_link_padding">
                <h3>Quick links</h3>
                <ul>
                  <li><Link to="#">Home </Link></li>
                  <li><Link to="#">Our Blog</Link></li>
                  <li><Link to="#">About Us</Link></li>
                  <li><Link to="#">Contact Us</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-4 col-xl-3 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
              <div className="footer_time">
                <h3>Working Hours:</h3>
                <ul>
                  <li><span>Mon - Fri</span> 9:00 AM - 6:00 PM</li>
                  <li><span>Saturday</span> 11:00 AM - 2:00 PM</li>
                  <li><span>Sunday</span> Close</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="footer_copyright">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="footer_copyright_text d-flex flex-wrap">
                  <p>  <a style={{color:"white"}} href='tel:+91 8982471422'>2026 © Designed by | Sewax Services Pvt. Ltd.</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* <PopUp /> */}
      <WhatsappIcon />



    </>
  )
}

export default Footer